import { fade } from "@material-ui/core/styles/colorManipulator";
import { lighten } from "@material-ui/core/styles/colorManipulator";
export const styles = (theme) => ({
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    minHeight: 300,
  },
  notiTable: {
    padding: "1.5rem",
    borderBottom: "solid 1px #dcdcdc",
  },
  tableContainer: {
    width: "100%",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
  paperRoot: {
    // paddingTop: theme.spacing(2),
    // paddingBottom: theme.spacing(2),
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
    marginTop: theme.spacing(3),
    // width: 'fit-content',
    width: "100%",
  },
  customColumn: {
    paddingTop: "0.8rem",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "0.8rem",
  },
  customerNameRow: {
    marginTop: "0.2rem",
    fontSize: "0.75rem",
    color: "#546e7a",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  iconEdit: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
  },
  iconWrap: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    padding: "4px",
  },
  iconActive: {
    color: "#1fa82b",
  },
  // iconNonActive: {
  //     color: '#bdbdbd',
  // },
  expired_border: {
    borderRight: "5px solid #ff2121",
  },
  non_expired_border: {
    borderRight: "5px solid #1fa82b",
  },
  will_expired_border: {
    borderRight: "5px solid #ff9221",
  },
  imgVoucher: {
    width: "9vw",
    height: "6vw",
    objectFit: "contain",
    maxWidth: "100px",
  },
  formControl: {
    width: "100%",
  },
  tableCellInCollapes: {
    borderBottom: "none",
  },
});

export const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  subTitle: {
    fontSize: "1.5rem",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "20%",
    float: "right",
  },
  icon: {
    marginTop: theme.spacing(3),
    width: 36,
    height: 36,
    left: -8,
  },
});
